module.exports = __webpack_public_path__ + "img/pig.8652b5c4.png";